import Header from "./Header";
import Footer from "./Footer";
import { HashLink } from "react-router-hash-link";
import ScrollToTopButton from "./ScrollToTopButton";

function Packages() {
  return (
    <>
      <Header />

      {/* <!-- -----------------------------------Packages----------------------------------- --> */}
      <section
        id="packages"
        className="w-100 h-100 pt-2"
        style={{ marginTop: "60px" }}
      >
        <div className="">
          <h2 className="text-center text-primary-emphasis pt-3 fs-1 fw-semibold">
            {" "}
            RAPID WELLNESS PACKAGES
          </h2>
        </div>
        {/* <!-- package set 1 --> */}
        <div className=" d-lg-flex d-md-flex justify-content-around d-grid gap-3 pt-3">
          {/* <!-- package 1 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/basic-wellness-package.jpeg"
              className="card-img-top img-thumbnail pt-2 "
              alt="basic-wellness-image"
            />
            <div className="card-body pt-2">
              <h5 className="card-title text-center text-primary-emphasis fs-5">
                Basic wellness package Men & Women & (outrage/ corporate events)
              </h5>

              <div className="pt-3 d-flex justify-content-center">
                <HashLink
                  to="/package-details#basic-wellness"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 2 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/executive-mens-package.jpeg"
              className="card-img-top img-thumbnail "
              alt="executive-mens-package-image"
            />
            <div className="card-body">
              <h5 className="card-title text-center  text-primary-emphasis fs-5">
                Executive Package for Men’s Wellness
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#executive-men"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 3 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/executive-package-for-women.jpeg "
              className="card-img-top img-thumbnail "
              alt="executive-package-for-women-image"
            />
            <div className="card-body">
              <h5 className="card-title text-center  text-primary-emphasis fs-5">
                Executive Package for Women’s complete Wellness
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#executive-women"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- package set 2 --> */}
        <div className=" d-lg-flex d-md-flex justify-content-around d-grid gap-3 pt-4">
          {/* <!-- package 1 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/paediatric-wellness.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title  text-primary-emphasis fs-5  text-center">
                Paediatric Wellness
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#paediatric"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>

          {/* <!-- package 2 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/womens-hormone-health.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title text-center text-primary-emphasis fs-5 ">
                Women’s Hormone Health
              </h5>

              <div className="pt-md-5 d-flex pt-lg-3 justify-content-center">
                <HashLink
                  to="/package-details#women's-hormone"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 3 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/mens-hormone-health.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title text-center text-primary-emphasis fs-5 ">
                Men’s Hormone Health
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <br />
                <br />
                <HashLink
                  to="/package-details#men's-hormone"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- package set 3 --> */}
        <div className=" d-lg-flex d-md-flex justify-content-around d-grid gap-3 pt-4">
          {/* <!-- package 1 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/testosterone-level.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title text-center  text-primary-emphasis fs-5 pt-">
                Testosterone Level
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#testosterone"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 2 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/heart-health.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title  text-primary-emphasis fs-5 text-center">
                Heart Health
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#heart-health"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 3 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/thyroid-health.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title text-center  text-primary-emphasis fs-5 pt-">
                Thyroid Health
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#thyroid-health"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- package set 4 --> */}
        <div className=" d-lg-flex d-md-flex justify-content-around d-grid gap-3 pt-4">
          {/* <!-- package 1 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/immune-health.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title text-center  text-primary-emphasis fs-5 pt-">
                Immune Health
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#immune-health"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 2 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/basic-nutrition.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title  text-primary-emphasis fs-5 text-center">
                Basic Nutrition & Lifestyle Risk
              </h5>
              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#basic-nutrition"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
          {/* <!-- package 3 --> */}
          <div className="card testimonial-card" style={{ width: "22rem" }}>
            <img
              loading="lazy"
              src="images/assets/pre-operative-testing.jpeg"
              className="card-img-top img-thumbnail"
              alt="..."
            />
            <div className="card-body">
              <h5 className="card-title text-center  text-primary-emphasis fs-4 pt-">
                Pre-Operative Testing
              </h5>

              <div className="pt-4 d-flex justify-content-center">
                <HashLink
                  to="/package-details#pre-operative"
                  className="btn btn-primary btn-lg"
                  smooth
                >
                  Learn more
                </HashLink>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTopButton />
      <Footer />
    </>
  );
}

export default Packages;
